import { Flex, Spinner } from '@applyboard/crystal-ui';

export function LoadingPage(): JSX.Element {
  return (
    <Flex direction="column" justify="center" align="center" gap={36} grow={0}>
      <Spinner size="lg" />
    </Flex>
  );
}
